// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question{
    padding: 0.625em 1.25em 1.4em;
    background: #161616;
    border-radius: 1.5em;
}
.question__top{
    display: flex;
    align-items: center;
    margin-bottom: 1em;
}
.question__ava{
    border-radius: 100%;
    width: 5.875rem;
    height: 5.875rem;
    background: #FF5317;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 4.55em;
    font-weight: 500;
    flex-shrink: 0;
    margin-right: 1.8125rem;
}
.question__name{
    margin-top: 0.5em;
    width: 12.8125em;
    height: 1.875em; 
    background: #FF5317;
    border-radius: 1.4375em;
}
.question__text{
    font-size: 0.875em;
    line-height: 1.286; 
    opacity: 0.7;
}
.question__content{
    margin-bottom: 1.25em;
}
.question__answers{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 0.75em;
}
.question__answer{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center; 
    background: #FFFFFF;
    border-radius: 0.75rem;
    margin-bottom: 0.875em;
    border: none;
    color: #000000;
    text-align: center;
    font-weight: 700;
    height: 2.5em;
}
.question__answers:not(.question__answers--answer) .question__answer:active, 
.question__answer.correct{
    background: #009465;
    color: #fff;
}
.question__answer.wrong{
    background: rgba(255, 255, 255, 0.25);
}
.question__answer:last-child{
    margin-bottom: 0;
}
.tips{
    padding: 1.8em 0 0.825em;
    transition: 0.3s padding;
    overflow: hidden;
    --var-margin-tips: 1;
    --var-margin-tips2: 1;
}
.tips__title{
    font-weight: 500;
    font-size: 1.125em;
    line-height: 1.333;
    padding: 0 1.1em;
    margin-bottom: 0.5em;
}
.tips__scroll{
    width: 100%;
    overflow: auto;
    padding-bottom: 0.8em;
}
.tips__wrapper{
    display: flex;
    align-items: flex-start;
    padding-left: 1em;
}
.tips__item{
    flex-shrink: 0;
    display: block;
    margin: 0 0.294em;
    position: relative;
}
.tips__item:last-child{
    padding-right: 1.25em;
    margin-right: 0;
}
.tips__image{
    display: block;
    width: 11.8125em;
    overflow: hidden; 
}
.tips__videoWrapper{
    margin: -1px;
    position: relative;
}
.tips__videoWrapper img{
    display: block;
    width: 100%; 
}
.tips__video{
    object-fit: cover;
    position: absolute;
    top: -1px;
    left: -1px; 
    width: calc(100% + 2px);
    height: calc(100% + 2px);
    z-index: 2; 
    pointer-events: none;
    opacity: 0;
}
.tips__video.load{
    opacity: 1;
}
.tips__videoBottom{
    position: absolute;
    z-index: 3;
    width: 100%;
    height: auto;
    left: 0;
    bottom: 0;
    pointer-events: none;
}
.tips__videoTop{
    position: absolute;
    z-index: 3;
    width: 100%;
    height: auto;
    left: 0;
    top: 0;
    pointer-events: none;
}
.tips__top{
    width: 100%;
    background: #fff; 
    position: relative;
    z-index: 3;
    border-radius: 0.75em 0.75em 0 0; 
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3em 0.7em 0.3em 0.5em;
}
.tips__topLeft{
    display: flex;
    align-items: center;
}
.tips__topAva{
    width: 1em;
    margin-right: 0.25em;
}
.tips__topHead{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.tips__topName{
    font-weight: 500;
    font-size: 0.472em;
    line-height: 1.3333; 
    color: #000000;
    position: relative;
    letter-spacing: -0.015333em;
}
.tips__topName svg{
    height: auto;
    width: 1em;
    position: absolute;
    top: 50%;
    left: 100%;
    transform: translateY(-60%);
    margin-left: 0.15em;
}
.tips__topSubs{
    color: rgba(0, 0, 0, 0.45);
    line-height: 1.23;
    font-size: 0.408em;
    font-feature-settings: 'pnum' on, 'lnum' on, 'ss02' on;
    font-weight: 500;
}
.tips__topDots{
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.tips__topDots svg{
    width: 0.5625em;
    height: auto;
}
.tips__bottom{
    background: #fff;
    position: relative;
    z-index: 3; 
    border-radius: 0 0 0.75em 0.75em;
    color: #000;
    padding: 0.2em 0.4em 0.5em;
}
.tips__bottomText{
    font-size: 0.44em;
    line-height: 1.29; 
    font-feature-settings: 'pnum' on, 'lnum' on, 'ss02' on; 
    color: rgba(0, 0, 0, 0.45);
    font-weight: 500;
    margin-bottom: 0.8em;
}
.tips__bottomIcos{
    display: flex;
    align-items: center;
    padding: 0 0.2em;
}
.tips__bottomIcos svg:last-child{
    margin-left: auto;
}
.tips__bottomIcos svg{
    height: 0.68em;
    width: auto;
}
.tips__bottomIcos span{
    color: rgba(0, 0, 0, 0.45);
    font-weight: 500;
    font-size: 0.44em;
    margin: 0 1.2em 0 0.5em;
}
.tips__bottomTitle{
    font-weight: 700;
    font-size: 0.563em;
    line-height: 1.22;
    margin-bottom: 0.33em;
    margin-top: 0.3em;
}
.tips__bottomExcerpt{
    font-size: 0.469em;
    line-height: 1.333;
    margin-bottom: 0.4em;
}
.frame:not(.frame--question) .tips{
    padding: 0;
    height: 0;
}
@media(min-width: 100vh){
    .question__answers:not(.question__answers--answer) .question__answer:hover{
        background: #009465;
        color: #fff;
    }
    .question{
        background: transparent;
        padding: 0;
        border-radius: 0;
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
    }
    .question__answers{
        padding: 0;
        margin-bottom: 3.75em;
        flex-direction: row;
    }
    .question__answer{
        flex-basis: 0;
        margin: 0 0.46875rem;
        white-space: nowrap;
        min-width: 15.625rem;
        height: 3.5rem;
        padding: 0 0.5rem;
        font-size: 1.25em;
    }
    .question__answers--wide .question__answer{
        min-width: 20rem;
    }
    .question__content{
        position: relative;
        z-index: 3;
        margin: 0;
        width: 15.625em;
        background: #fff;
        border-radius: 1.25em;
        padding: 1.5625em 1.25em 2.3125em;
    }
    .question__top{
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 0.75em;
    }
    .question__ava{
        margin: 0 0 1.3125rem 0.3125rem;
    }
    .question__name{
        margin: 0;
    }
    .tips__topName svg{
        transform: translateY(-50%);
    }
    .question__text{
        color: #000000;
        font-size: 0.75em;
        line-height: 1.16666;
        opacity: 1;
        padding: 0 0.4em;
    }
    .tips__scroll,
    .tips__wrapper,
    .tips{
        padding: 0;
        overflow: inherit;
    }
    .tips__title{
        display: none;
    }
    .tips__item:last-child,
    .tips__item{
        margin: 0;
        padding: 0;
        position: absolute;
        top: 0;
        left: 50%;
        transition: 1s margin, 0.3s transform; 
    }
    .tips__image{
        width: 13.126em;
    }
    .tips__item:nth-child(1){
        z-index: 2;
        margin-top: 19.7em;
        margin-left: calc(var(--var-margin-tips) * -35.7em);
    }
    .tips__item:nth-child(1) .tips__image{
        transform: rotate(6deg);    
    }
    .tips__item:nth-child(2){ 
        margin-top: 24.8em;
        margin-left: calc(var(--var-margin-tips) * -22.7em);
    }
    .tips__item:nth-child(2) .tips__image{
        transform: rotate(-9deg);    
    }
    .tips__item:nth-child(3){ 
        margin-top: 25.3em;
        margin-left: calc(var(--var-margin-tips2) * 7.2em);
    }
    .tips__item:nth-child(3) .tips__image{
        transform: rotate(10deg);    
    }
    .tips__item:nth-child(4){
        z-index: 2; 
        margin-top: 21.5em;
        margin-left: calc(var(--var-margin-tips) * 20.6em);
    }
    .tips__item:nth-child(4) .tips__image{
        transform: rotate(-11deg);    
    }
    .tips__bottom,  
    .tips__top{
        font-size: 1.14em;
    }
    .frame:not(.frame--question) .tips{
        --var-margin-tips: 4;
        --var-margin-tips2: 10;
        pointer-events: none;
        animation: fadeOut 4s linear 2s normal infinite;   
    }
    .tips__item:hover{
        transform: scale(1.05);
    }
    .frame.frame--answer:not(.frame--question) .tips{
        --var-margin-tips: 1;
        --var-margin-tips2: 1;
        pointer-events: all;
        animation: none;   
    }
    .frame.frame--answer .tips__item:nth-child(1) {
        z-index: 2;
        margin-top: 13.9em;
        margin-left: -53.4em;
    }
    .frame.frame--answer .tips__item:nth-child(2) {
        margin-top: 27.8em;
        margin-left: -45.3em;
    }
    .frame.frame--answer .tips__item:nth-child(3) {
        margin-top: 22em;
        margin-left: 36.8em;
    }
    .frame.frame--answer .tips__item:nth-child(4) {
        z-index: 2;
        margin-top: 9.7em;
        margin-left: 42em;
    }
    .frame.frame--answer .tips__item video{
        opacity: 0;
    }
}
@media(min-width: 100vh) and (max-width:  180vh){
    .frame.frame--answer .tips__item:nth-child(1) { 
        margin-left: -47.4em;
    }
    .frame.frame--answer .tips__item:nth-child(2) { 
        margin-left: -39.3em;
    }
    .frame.frame--answer .tips__item:nth-child(3) { 
        margin-left: 30.8em;
    }
    .frame.frame--answer .tips__item:nth-child(4) { 
        margin-left: 36em;
    }
}`, "",{"version":3,"sources":["webpack://./src/routes/Question/question.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;AACA;;IAEI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,qCAAqC;AACzC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,wBAAwB;IACxB,UAAU;IACV,oBAAoB;IACpB,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,OAAO;IACP,SAAS;IACT,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,sDAAsD;IACtD,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,gCAAgC;IAChC,WAAW;IACX,0BAA0B;AAC9B;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,sDAAsD;IACtD,0BAA0B;IAC1B,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI;QACI,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,uBAAuB;QACvB,UAAU;QACV,gBAAgB;QAChB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,qBAAqB;QACrB,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;QACpB,cAAc;QACd,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,qBAAqB;QACrB,iCAAiC;IACrC;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,qBAAqB;IACzB;IACA;QACI,+BAA+B;IACnC;IACA;QACI,SAAS;IACb;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,cAAc;QACd,iBAAiB;QACjB,oBAAoB;QACpB,UAAU;QACV,gBAAgB;IACpB;IACA;;;QAGI,UAAU;QACV,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;IACA;;QAEI,SAAS;QACT,UAAU;QACV,kBAAkB;QAClB,MAAM;QACN,SAAS;QACT,qCAAqC;IACzC;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,kBAAkB;QAClB,mDAAmD;IACvD;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,kBAAkB;QAClB,mDAAmD;IACvD;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,kBAAkB;QAClB,kDAAkD;IACtD;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,kBAAkB;QAClB,kDAAkD;IACtD;IACA;QACI,yBAAyB;IAC7B;IACA;;QAEI,iBAAiB;IACrB;IACA;QACI,oBAAoB;QACpB,sBAAsB;QACtB,oBAAoB;QACpB,+CAA+C;IACnD;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,oBAAoB;QACpB,qBAAqB;QACrB,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,UAAU;QACV,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,oBAAoB;IACxB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".question{\n    padding: 0.625em 1.25em 1.4em;\n    background: #161616;\n    border-radius: 1.5em;\n}\n.question__top{\n    display: flex;\n    align-items: center;\n    margin-bottom: 1em;\n}\n.question__ava{\n    border-radius: 100%;\n    width: 5.875rem;\n    height: 5.875rem;\n    background: #FF5317;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 4.55em;\n    font-weight: 500;\n    flex-shrink: 0;\n    margin-right: 1.8125rem;\n}\n.question__name{\n    margin-top: 0.5em;\n    width: 12.8125em;\n    height: 1.875em; \n    background: #FF5317;\n    border-radius: 1.4375em;\n}\n.question__text{\n    font-size: 0.875em;\n    line-height: 1.286; \n    opacity: 0.7;\n}\n.question__content{\n    margin-bottom: 1.25em;\n}\n.question__answers{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 0 0.75em;\n}\n.question__answer{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center; \n    background: #FFFFFF;\n    border-radius: 0.75rem;\n    margin-bottom: 0.875em;\n    border: none;\n    color: #000000;\n    text-align: center;\n    font-weight: 700;\n    height: 2.5em;\n}\n.question__answers:not(.question__answers--answer) .question__answer:active, \n.question__answer.correct{\n    background: #009465;\n    color: #fff;\n}\n.question__answer.wrong{\n    background: rgba(255, 255, 255, 0.25);\n}\n.question__answer:last-child{\n    margin-bottom: 0;\n}\n.tips{\n    padding: 1.8em 0 0.825em;\n    transition: 0.3s padding;\n    overflow: hidden;\n    --var-margin-tips: 1;\n    --var-margin-tips2: 1;\n}\n.tips__title{\n    font-weight: 500;\n    font-size: 1.125em;\n    line-height: 1.333;\n    padding: 0 1.1em;\n    margin-bottom: 0.5em;\n}\n.tips__scroll{\n    width: 100%;\n    overflow: auto;\n    padding-bottom: 0.8em;\n}\n.tips__wrapper{\n    display: flex;\n    align-items: flex-start;\n    padding-left: 1em;\n}\n.tips__item{\n    flex-shrink: 0;\n    display: block;\n    margin: 0 0.294em;\n    position: relative;\n}\n.tips__item:last-child{\n    padding-right: 1.25em;\n    margin-right: 0;\n}\n.tips__image{\n    display: block;\n    width: 11.8125em;\n    overflow: hidden; \n}\n.tips__videoWrapper{\n    margin: -1px;\n    position: relative;\n}\n.tips__videoWrapper img{\n    display: block;\n    width: 100%; \n}\n.tips__video{\n    object-fit: cover;\n    position: absolute;\n    top: -1px;\n    left: -1px; \n    width: calc(100% + 2px);\n    height: calc(100% + 2px);\n    z-index: 2; \n    pointer-events: none;\n    opacity: 0;\n}\n.tips__video.load{\n    opacity: 1;\n}\n.tips__videoBottom{\n    position: absolute;\n    z-index: 3;\n    width: 100%;\n    height: auto;\n    left: 0;\n    bottom: 0;\n    pointer-events: none;\n}\n.tips__videoTop{\n    position: absolute;\n    z-index: 3;\n    width: 100%;\n    height: auto;\n    left: 0;\n    top: 0;\n    pointer-events: none;\n}\n.tips__top{\n    width: 100%;\n    background: #fff; \n    position: relative;\n    z-index: 3;\n    border-radius: 0.75em 0.75em 0 0; \n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.3em 0.7em 0.3em 0.5em;\n}\n.tips__topLeft{\n    display: flex;\n    align-items: center;\n}\n.tips__topAva{\n    width: 1em;\n    margin-right: 0.25em;\n}\n.tips__topHead{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n.tips__topName{\n    font-weight: 500;\n    font-size: 0.472em;\n    line-height: 1.3333; \n    color: #000000;\n    position: relative;\n    letter-spacing: -0.015333em;\n}\n.tips__topName svg{\n    height: auto;\n    width: 1em;\n    position: absolute;\n    top: 50%;\n    left: 100%;\n    transform: translateY(-60%);\n    margin-left: 0.15em;\n}\n.tips__topSubs{\n    color: rgba(0, 0, 0, 0.45);\n    line-height: 1.23;\n    font-size: 0.408em;\n    font-feature-settings: 'pnum' on, 'lnum' on, 'ss02' on;\n    font-weight: 500;\n}\n.tips__topDots{\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.tips__topDots svg{\n    width: 0.5625em;\n    height: auto;\n}\n.tips__bottom{\n    background: #fff;\n    position: relative;\n    z-index: 3; \n    border-radius: 0 0 0.75em 0.75em;\n    color: #000;\n    padding: 0.2em 0.4em 0.5em;\n}\n.tips__bottomText{\n    font-size: 0.44em;\n    line-height: 1.29; \n    font-feature-settings: 'pnum' on, 'lnum' on, 'ss02' on; \n    color: rgba(0, 0, 0, 0.45);\n    font-weight: 500;\n    margin-bottom: 0.8em;\n}\n.tips__bottomIcos{\n    display: flex;\n    align-items: center;\n    padding: 0 0.2em;\n}\n.tips__bottomIcos svg:last-child{\n    margin-left: auto;\n}\n.tips__bottomIcos svg{\n    height: 0.68em;\n    width: auto;\n}\n.tips__bottomIcos span{\n    color: rgba(0, 0, 0, 0.45);\n    font-weight: 500;\n    font-size: 0.44em;\n    margin: 0 1.2em 0 0.5em;\n}\n.tips__bottomTitle{\n    font-weight: 700;\n    font-size: 0.563em;\n    line-height: 1.22;\n    margin-bottom: 0.33em;\n    margin-top: 0.3em;\n}\n.tips__bottomExcerpt{\n    font-size: 0.469em;\n    line-height: 1.333;\n    margin-bottom: 0.4em;\n}\n.frame:not(.frame--question) .tips{\n    padding: 0;\n    height: 0;\n}\n@media(min-width: 100vh){\n    .question__answers:not(.question__answers--answer) .question__answer:hover{\n        background: #009465;\n        color: #fff;\n    }\n    .question{\n        background: transparent;\n        padding: 0;\n        border-radius: 0;\n        display: flex;\n        flex-direction: column-reverse;\n        align-items: center;\n    }\n    .question__answers{\n        padding: 0;\n        margin-bottom: 3.75em;\n        flex-direction: row;\n    }\n    .question__answer{\n        flex-basis: 0;\n        margin: 0 0.46875rem;\n        white-space: nowrap;\n        min-width: 15.625rem;\n        height: 3.5rem;\n        padding: 0 0.5rem;\n        font-size: 1.25em;\n    }\n    .question__answers--wide .question__answer{\n        min-width: 20rem;\n    }\n    .question__content{\n        position: relative;\n        z-index: 3;\n        margin: 0;\n        width: 15.625em;\n        background: #fff;\n        border-radius: 1.25em;\n        padding: 1.5625em 1.25em 2.3125em;\n    }\n    .question__top{\n        flex-direction: column;\n        align-items: flex-start;\n        margin-bottom: 0.75em;\n    }\n    .question__ava{\n        margin: 0 0 1.3125rem 0.3125rem;\n    }\n    .question__name{\n        margin: 0;\n    }\n    .tips__topName svg{\n        transform: translateY(-50%);\n    }\n    .question__text{\n        color: #000000;\n        font-size: 0.75em;\n        line-height: 1.16666;\n        opacity: 1;\n        padding: 0 0.4em;\n    }\n    .tips__scroll,\n    .tips__wrapper,\n    .tips{\n        padding: 0;\n        overflow: inherit;\n    }\n    .tips__title{\n        display: none;\n    }\n    .tips__item:last-child,\n    .tips__item{\n        margin: 0;\n        padding: 0;\n        position: absolute;\n        top: 0;\n        left: 50%;\n        transition: 1s margin, 0.3s transform; \n    }\n    .tips__image{\n        width: 13.126em;\n    }\n    .tips__item:nth-child(1){\n        z-index: 2;\n        margin-top: 19.7em;\n        margin-left: calc(var(--var-margin-tips) * -35.7em);\n    }\n    .tips__item:nth-child(1) .tips__image{\n        transform: rotate(6deg);    \n    }\n    .tips__item:nth-child(2){ \n        margin-top: 24.8em;\n        margin-left: calc(var(--var-margin-tips) * -22.7em);\n    }\n    .tips__item:nth-child(2) .tips__image{\n        transform: rotate(-9deg);    \n    }\n    .tips__item:nth-child(3){ \n        margin-top: 25.3em;\n        margin-left: calc(var(--var-margin-tips2) * 7.2em);\n    }\n    .tips__item:nth-child(3) .tips__image{\n        transform: rotate(10deg);    \n    }\n    .tips__item:nth-child(4){\n        z-index: 2; \n        margin-top: 21.5em;\n        margin-left: calc(var(--var-margin-tips) * 20.6em);\n    }\n    .tips__item:nth-child(4) .tips__image{\n        transform: rotate(-11deg);    \n    }\n    .tips__bottom,  \n    .tips__top{\n        font-size: 1.14em;\n    }\n    .frame:not(.frame--question) .tips{\n        --var-margin-tips: 4;\n        --var-margin-tips2: 10;\n        pointer-events: none;\n        animation: fadeOut 4s linear 2s normal infinite;   \n    }\n    .tips__item:hover{\n        transform: scale(1.05);\n    }\n    .frame.frame--answer:not(.frame--question) .tips{\n        --var-margin-tips: 1;\n        --var-margin-tips2: 1;\n        pointer-events: all;\n        animation: none;   \n    }\n    .frame.frame--answer .tips__item:nth-child(1) {\n        z-index: 2;\n        margin-top: 13.9em;\n        margin-left: -53.4em;\n    }\n    .frame.frame--answer .tips__item:nth-child(2) {\n        margin-top: 27.8em;\n        margin-left: -45.3em;\n    }\n    .frame.frame--answer .tips__item:nth-child(3) {\n        margin-top: 22em;\n        margin-left: 36.8em;\n    }\n    .frame.frame--answer .tips__item:nth-child(4) {\n        z-index: 2;\n        margin-top: 9.7em;\n        margin-left: 42em;\n    }\n    .frame.frame--answer .tips__item video{\n        opacity: 0;\n    }\n}\n@media(min-width: 100vh) and (max-width:  180vh){\n    .frame.frame--answer .tips__item:nth-child(1) { \n        margin-left: -47.4em;\n    }\n    .frame.frame--answer .tips__item:nth-child(2) { \n        margin-left: -39.3em;\n    }\n    .frame.frame--answer .tips__item:nth-child(3) { \n        margin-left: 30.8em;\n    }\n    .frame.frame--answer .tips__item:nth-child(4) { \n        margin-left: 36em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
